// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","453":"8701dc61","455":"7300937d"}[chunkId] + ".chunk.js";
};